import DefaultSelect from '@hero/ui-kit/inputs/DefaultSelect';
import Form from '@hero/ui-kit/inputs/Form';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { noop } from 'ts-essentials';
import * as yup from 'yup';

export const activeStatus = yup
    .object()
    .shape({
        show_inactive: yup.string().nullable()
    })
    .defined();

export type ActiveStatusParams = yup.InferType<typeof activeStatus>;

const ActiveFilter: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <Form
            validationSchema={activeStatus}
            submitFn={noop}
            defaultValues={{
                show_inactive: searchParams.get('show_inactive') || 'false'
            }}
        >
            <DefaultSelect
                styles={{ minWidth: '180px' }}
                name="show_inactive"
                onChange={(e) => {
                    const value = e.currentTarget.value;

                    setSearchParams((prevState) => {
                        if (value === 'false') {
                            prevState.delete('show_inactive');
                        } else {
                            prevState.set('show_inactive', value);
                        }
                        return prevState;
                    });
                }}
                options={[
                    { label: 'All', value: 'true' },
                    { label: 'Only Active', value: 'false' }
                ]}
            />
        </Form>
    );
};

export default ActiveFilter;
